import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META, { type WorkspaceAgentActionsMenuOpenedLocation } from './useTrackAgentActionsMenuOpened.meta';
import { withWorkspaceAgentCategory } from './workspaceAgentAnalytics';

export type { WorkspaceAgentActionsMenuOpenedLocation } from './useTrackAgentActionsMenuOpened.meta';

export type UseTrackAgentActionsMenuOpenedParams = {
  location: WorkspaceAgentActionsMenuOpenedLocation;
};

export const useTrackAgentActionsMenuOpened = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentActionsMenuOpened = useCallback(
    (params: UseTrackAgentActionsMenuOpenedParams) => {
      track(META.name, withWorkspaceAgentCategory(params));
    },
    [track],
  );

  return { trackAgentActionsMenuOpened };
};
